<template>
  <v-menu
    :close-on-click="true"
    :rounded="true"
    transition="scale-transition"
    :close-on-content-click="true"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on">
        <span class="white-text">{{ $_currentGeoSectionExtra }} </span>
        <v-icon color="white">mdi-map-marker</v-icon>
      </v-btn>
    </template>
    <v-list nav class="pa-5">
      <v-list-item-group color="primary">
        <v-list-item
          link
          v-for="item in arterMenuPartOne"
          :key="item.name"
          @click="setGeoArea(item.code)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="setGeoLocation()">
          <v-list-item-content>
            <v-list-item-title>Nära mig</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import GeoStuff from '@/mixins/GeoStuff.js'
export default {
  name: 'GeoSelect',
  mixins: [GeoStuff],
  data() {
    return {
      geoHav: ['VÄSTERHAVET', 'ÖSTERSJÖN', 'SVENSKA HAV'],
      arterMenuPartOne: [
        { name: 'Svenska hav', code: 'all' },
        { name: 'Östersjön', code: 'ost' },
        { name: 'Västerhavet', code: 'vast' }
      ],
      arterMenuPartTwo: [
        { code: 'ab', name: 'Stockholms län' },
        { code: 'c', name: 'Uppsala län' },
        { code: 'd', name: 'Södermanlands län' },
        { code: 'e', name: 'Östergötlands län' },
        { code: 'h', name: 'Kalmar län' },
        { code: 'i', name: 'Gotlands län' },
        { code: 'm', name: 'Blekinge län' },
        { code: 'k', name: 'Skåne län' },
        { code: 'n', name: 'Hallands län' },
        { code: 'o', name: 'Västra Götalands län' },
        { code: 'x', name: 'Gävleborgs län' },
        { code: 'y', name: 'Västernorrlands län' },
        { code: 'ac', name: 'Västerbottens län' },
        { code: 'bd', name: 'Norrbottens län' }
      ]
    }
  },
  methods: {
    setGeoArea(strAreaCode) {
      this.isOpen = false
      this.$router.replace({ query: { area: strAreaCode } })
    },
    async setGeoLocation() {
      this.isOpen = false
      const init = await this.$store.dispatch('setGeoLocation')
      this.$router.replace({ query: { area: init } })
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  max-width: unset;
  width: fit-content;
}
.sub-header {
  color: green !important;
  font-weight: 600;
  font-size: 0.8125rem;
}
.white-text {
  color: white;
}
</style>
